<template>
  <div class="row">
    <div class="col-md-6">
      <list-document-types
        class="w-100"
        autocomplete
        label="Tipo Documento"
        data-cy="relate-document-type"
        name="relatedDocumentType"
        data-vv-as="tipo documento"
        ref="relatedDocumentType"
        v-model="relatedDocument.type"
        :danger="errors.has('flow-part-1-2.relatedDocumentType')"
        :danger-text="errors.first('flow-part-1-2.relatedDocumentType')"
        v-validate="'required'"
      />
    </div>
    <div class="col-md-6">
      <vs-input
        class="w-100"
        label="Nº Documento"
        data-cy="related-document-number"
        name="relatedDocumentNumber"
        v-model="relatedDocument.number"
        v-validate="'required'"
        :danger="errors.has('flow-part-1-2.relatedDocumentNumber')"
        :danger-text="errors.first('flow-part-1-2.relatedDocumentNumber')"
        autocomplete="off"
      />
    </div>
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <vs-button
        data-cy="add-relation"
        color="primary"
        icon="add"
        v-on:click="addRelatedDocument()"
      >
        Agregar relación
      </vs-button>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

import ListDocumentTypes from '@/febos/chile/lists/components/ListDocumentTypes';

export default {
  directives: {
    Ripple
  },
  components: {
    ListDocumentTypes
  },
  data() {
    return {
      relatedDocument: {
        type: '',
        number: ''
      }
    };
  },
  methods: {
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addRelatedDocument() {
      const isValid = await this.validateForm('flow-part-1-2');
      if (!isValid) {
        return;
      }

      const row = {
        id: this.relatedDocument.length,
        type: this.relatedDocument.type,
        number: this.relatedDocument.number
      };

      this.$emit('add-related-document', row);

      this.relatedDocument.type = '';
      this.relatedDocument.number = '';

      await this.$validator.reset();
    }
  }
};
</script>
